var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$wf.isMdUp
    ? _c("app-desktop-edit", { attrs: { state: _vm.state } })
    : _c("app-mobile-edit", { attrs: { state: _vm.state } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }